import React, { useEffect } from "react"
import ThumbsUp from "@/assets/clipart/techny-thumb-up-icon.svg"
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withTiming,
  Easing,
} from "react-native-reanimated"

const ThumbsUpAnimated = () => {
  const rotation = useSharedValue(0)
  const scale = useSharedValue(0.4) // Start scaling from 40%
  const opacity = useSharedValue(0) // Start fully transparent

  const animatedStyles = useAnimatedStyle(() => {
    return {
      opacity: opacity.value,
      transform: [{ rotateZ: `${rotation.value}deg` }, { scale: scale.value }],
    }
  })

  useEffect(() => {
    const timer = setTimeout(() => {
      // Simultaneous fade in and scale up as initial part of the sequence
      opacity.value = withTiming(1, { duration: 500, easing: Easing.ease })
      scale.value = withTiming(1, { duration: 500, easing: Easing.ease })

      // Full sequence including initial zoom and subsequent jiggles
      rotation.value = withSequence(
        withTiming(0, { duration: 700 }), // Wait while scaling and fading in
        // @ts-expect-error: Delay is actually supported and the animation works
        withTiming(-12, { duration: 100, delay: 3800, easing: Easing.ease }),
        withTiming(12, { duration: 200, easing: Easing.ease }),
        withTiming(-15, { duration: 150, easing: Easing.ease }),
        withTiming(15, { duration: 190, easing: Easing.ease }),
        withTiming(0, { duration: 150, easing: Easing.ease })
      )
    }, 100)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <Animated.View style={animatedStyles}>
      <ThumbsUp />
    </Animated.View>
  )
}

export default ThumbsUpAnimated
